import React from "react";
import { FaFacebookF } from "react-icons/fa";
import { SiGmail } from "react-icons/si";
import { AiFillInstagram } from "react-icons/ai";
import { FaTwitter } from "react-icons/fa";
import { IoCall } from "react-icons/io5";
import { FaLocationDot } from "react-icons/fa6";
import { Link, NavLink } from "react-router-dom";
import { FaLinkedin } from "react-icons/fa";
import "./footer.css";

const Footer = () => {
	return (
		<footer className="footer d-flex">
			<ul className="footer-icons d-flex">
				<li>
					<a
						href="https://www.facebook.com/share/163MeNyQgj/"
						target="_blank"
						rel="noopener noreferrer">
						<FaFacebookF className="f-icons" />
					</a>
				</li>
				<li>
					<a
						href="https://www.instagram.com/xeyex_media_private_limited?igsh=OWZheXdxYTN0cGx0"
						target="_blank"
						rel="noopener noreferrer">
						<AiFillInstagram className="f-icons" />
					</a>
				</li>
				<li>
					<a
						href="https://www.linkedin.com/in/xeyex-media-private-limited-928439354?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
						target="_blank"
						rel="noopener noreferrer">
						<FaLinkedin className="f-icons" />
					</a>
				</li>
			</ul>
			<p className="center-text-f text-center" style={{ color: "var(--primary-text)" }}>
				&copy; 2024 XEYEX.MEDIA . All rights reserved.
			</p>
			<ul className="footer-links d-flex">
				<div className="aligning_div">
					<li>
						<a href="tel:8608257794">
							<div className="footer-p-details">
								<div className="footer-r-icon">
									<IoCall className="f-icons" />
								</div>
								<p>8608257794</p>
							</div>
						</a>
					</li>
					<li>
						<a href="mailto:xeyex.media.private.limited@gmail.com?subject=Inquiry&body=Hello, I want to learn more about your services.">
							<div className="footer-p-details">
								<div className="footer-r-icon" id="gmail_icon">
									<SiGmail className="f-icons" />
								</div>
								<p>xeyex.media.private.limited@gmail.com</p>
							</div>
						</a>
					</li>
					<li>
						<a href="#">
							<div className="footer-p-details">
								<div className="footer-r-icon">
									<FaLocationDot className="f-icons" />
								</div>
								<p>No.4 water tank street, Kurumampet, Pondicherry- 605009</p>
							</div>
						</a>
					</li>
				</div>
			</ul>
		</footer>
	);
};

export default Footer;
